"use client";

import { useContext, useState } from "react";
import startCase from "lodash/startCase";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import {
  ResponsiveDrawerDropdown,
  DropdownToggle,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";

import styles from "./main.module.scss";

const DropDown = ({
  dropDownItems,
  fieldValue,
  setFieldValue,
}: {
  dropDownItems: any[];
  fieldValue: string;
  setFieldValue: (value: any) => void;
}) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const [showDropDownOptions, setShowDropDownOptions] = useState(false);
  const toggleDropDownOption = () => setShowDropDownOptions(!showDropDownOptions);

  return (
    <ResponsiveDrawerDropdown
      show={showDropDownOptions}
      onToggle={toggleDropDownOption}
      styles={styles}
      menuClassName={styles.dropDownOptions}
      enablePortal={isMobileDevice}
      label={
        <DropdownToggle styles={styles} truncate className={styles.categoryMenu}>
          {fieldValue ? (
            <span className={styles.categoryMenuItemText}>
              {startCase(dropDownItems.find((item) => item.code === fieldValue)?.name)}
            </span>
          ) : (
            <div className={styles.placeholderText}>Select an option</div>
          )}
        </DropdownToggle>
      }
      heading={<DropdownToggle>Select an option</DropdownToggle>}
    >
      {dropDownItems.map(({ code, name }) => (
        <DropdownItem
          styles={styles}
          key={code}
          onSelect={() => setFieldValue(code)}
          className={styles.categoryMenuItem}
          isActive={fieldValue === code}
        >
          <div className={styles.dropdownItemTextContainer}>
            <div className={styles.dropdownItemText}>
              <span>{startCase(name)}</span>
            </div>
          </div>
        </DropdownItem>
      ))}
    </ResponsiveDrawerDropdown>
  );
};

export default DropDown;
